let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3I48u")).then(() => parcelRequire('hTzue'));